var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5H7.5C6.67275 1.5 6 2.17275 6 3V6H3C2.17275 6 1.5 6.67275 1.5 7.5V15C1.5 15.8273 2.17275 16.5 3 16.5H10.5C11.3273 16.5 12 15.8273 12 15V12H15C15.8273 12 16.5 11.3273 16.5 10.5V3C16.5 2.17275 15.8273 1.5 15 1.5ZM3 15V7.5H10.5L10.5015 15H3ZM15 10.5H12V7.5C12 6.67275 11.3273 6 10.5 6H7.5V3H15V10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.24a3a1d6c3b35c4d1aca23dbe238861f.svg";
export { ForwardRef as ReactComponent };